import React from 'react'
import './task-date-popup.css'


export function TaskDatePopup(props) {

    function clickClose() {
        let newDueDate;
        if(props.dateChange) {
            if(props.subtask) {
                newDueDate = props.subtask.subtaskDueDate
            } else {
                newDueDate = props.todo.todoDueDate
            }
        }
        props.toggleAlarmClick(newDueDate)
    }

    function dueDateReset() {
        let newDueDate = document.getElementById('new-due-date').value
        props.toggleAlarmClick(newDueDate)
        // setTimeout(function(){
        //     if(props.sortByDueDate) {
        //         props.sortByDueDate()
        //     }
        // }, 0)
    }

    if(props.dateChange === true) {
        let finalDateFormat = ''
        let todaysDate;
        function createDate() {
            if(props.subtask !== undefined) {
                todaysDate = new Date(props.subtask.subtaskDueDate)
            } else {
                todaysDate = new Date(props.todo.todoDueDate)
            }
            let theMonth = ''
            let todaysMonth = todaysDate.getMonth() + 1
            if(todaysMonth < 10) {
                theMonth = `0${todaysMonth}`
            } else {
                theMonth = todaysMonth
            }
            let theDay = ''
            if(todaysDate.getDate() < 10) {
                theDay = `0${todaysDate.getDate()}`
            } else {
                theDay = todaysDate.getDate()
            }
            finalDateFormat = `${todaysDate.getFullYear()}-${theMonth}-${theDay}T10:00:00`
        }
        createDate()
        if(props.subtask) {
            return(
                <div className="date-popup-wrapper">
                    <div className="background-darker" id="background-darker"></div>
                    <div className="date-popup-box" id="date-popup-box">
                        <div className="little-square"></div>
                        <div>Change due date</div>
                        <input id="new-due-date" type="datetime-local" defaultValue={finalDateFormat} className="popup-date-selector"></input>
                        <div className="save-date-button" id="save-date-button" onClick={() => dueDateReset()}>Save</div>
                    </div>
                </div>
            )
        } else {
            return(
                <div className="date-popup-wrapper">
                    <div className="background-darker" id="background-darker"></div>
                    <div className="date-popup-box for-main-screen" id="date-popup-box">
                        <div className="little-square"></div>
                        <div>Change due date</div>
                        <input id="new-due-date" type="datetime-local" defaultValue={finalDateFormat} className="popup-date-selector"></input>
                        <div className="save-date-button" id="save-date-button" onClick={() => dueDateReset()}>Save</div>
                    </div>
                </div>
            )
        }
    } else {
        return null
    }
}